module.exports = __webpack_public_path__ + "assets/img/logo-iframe.f9911cf1.svg";